module.exports = __webpack_public_path__ + "img/samsung.608d6f85.svg";